import { Typography } from "@mui/material"
import React from "react"

import "./NewsCard.css"

const NewsCard = ({ data }) => {
	//console.log(data.CONTENT)
	const work_date = new Date(
		data.DATE.seconds * 1000 + data.DATE.nanoseconds / 1000000
	)
	let textFields = <div>Adquiring data...</div>
	textFields = data.CONTENT.map((line, index) => (
		<Typography key={index}>{line}</Typography>
	))

	//console.log(data.IMG_URL)

	return (
		<div className="news-card-blog-post-card">
			<img alt={data.TITLE} src={data.IMG_URL} className="news-card-image" />
			<div className="news-card-container">
				<div className="news-card-container1">
					<span className="news-card-titleText">{data.TITLE}</span>
					<span className="news-card-dateText">
						{work_date.toLocaleString()}
					</span>
				</div>
				<h1 className="news-card-text2">{data.TITLE}</h1>
				<span className="news-card-text">{textFields}</span>
				<div className="news-card-container2">
					<div className="news-card-profile"></div>
					{data.CONTENT_URL && (
						<a className="news-card-text4" href={data.CONTENT_URL}>
							Saber más -&gt;
						</a>
					)}
				</div>
			</div>
		</div>
	)
}

export default NewsCard
